// Import Core
import React from 'react';
// import { Link } from 'gatsby';
// Import Libraries
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import Slider from 'react-slick';
// Import Components
import { Button } from '../../ui/Button';
import SectionTitle from '../../ui/SectionTitle';
// Import Utils
import { GetLinks } from '../../../utils/getNavItemLinks';
// Import Styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// Import Assets
import chevronLeft from '../../../assets/images/chevronLeft.svg';

/* Slider Settings */
const sliderSettings = {
	slidesToShow: 3,
	slidesToScroll: 1,
	infinite: false,
	arrows: true,

	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};

/* Styled Components */
// TODO: THESE ARROWS AND DOTS FROM HOTELHERO CAN GO IN GLOBAL!!!!
const SliderStyles = styled(Slider)`
	/* reduce left & right padding by 10px to accomodate box shadow on cards */
	/* Add 70px to bottom padding to accomodate slick arrows (postition: absolute) */
	padding: 40px 110px calc(64px + 70px);
	gap: 32px;
	display: flex;
	flex-direction: column;
	@media (max-width: 992px) {
		padding: 20px 54px calc(64px + 70px);
	}
	@media (max-width: 768px) {
		padding: 20px 24px calc(64px + 70px);
	}

	/* .slick-slider { */
	/* max-width: 100%; */
	/* width: 100%;
	height: 100%; */
	/* margin-left: auto; */
	/* @media (max-width: 768px) {
				width: 100%;
				height: 50vh;
			} */
	.slick-list {
		/* height: 100%; */
		.slick-track {
			/* height: 100%; */
			/* display: flex!important; */
			gap: 32px;
			&:before,
			&:after {
				display: none;
			}
			.slick-slide {
				/* height: 100%; */
				/* height: inherit !important; */
				/* margin-right: -80px; */
				/* display: flex;
            align-items: flex-start;
            justify-content: center;
            gap: 40px; */
				&:first-child {
					padding-left: 10px;
				}
				&:last-child {
					padding-right: 10px;
				}
				> div:first-child {
					height: 100%;
					/* height: fit-content; */
					position: relative;

					.card {
						display: flex !important;
						margin-bottom: 8px;
						height: calc(100% - 8px);

						.card_link {
							margin-top: auto;
						}
					}
				}
				.gatsby-image-wrapper {
					min-height: 200px;
					height: 200px;
				}
			}
		}
	}

	.slick-arrow {
		/* z-index: 1; */
		position: absolute;
		/* top: 50%; */
		left: 50px;
		width: 67px;
		height: 67px;
		/* background: var(--primary-500); */
		/* border-radius: 50%; */
		right: unset;
		left: unset;
		top: unset;
		/* bottom: -70px; */
		bottom: 0;

		/* &:before {
			content: '';
			background-image: url(${chevronLeft});
			filter: invert(100%) sepia(2%) saturate(2%) hue-rotate(354deg)
				brightness(118%) contrast(100%);
			background-size: 20px;
			background-position: center;
			background-repeat: no-repeat;
			width: 100%;
			height: 100%;
			display: block;
		} */
		&.slick-prev {
			/* left: 150px; */
			margin-left: 10px;
			@media (max-width: 992px) {
			}
			@media (max-width: 768px) {
				margin-left: 0;
				left: calc(50% - 67px - 20px);
				right: 0;
			}
		}

		&.slick-next {
			left: calc(120px + 67px + 40px);
			@media (max-width: 992px) {
			}
			@media (max-width: 768px) {
				left: unset;
				right: calc(50% - 67px - 20px);
			}

			/* &:before {
				transform: rotate(180deg);
			} */
		}
		/* } */

		/* .slick-dots {
				text-align: right;
				right: 140px;
				bottom: 22px;
				margin: 0;
				width: inherit;
				display: none;
				@media (max-width: 768px) {
					text-align: left;
					right: unset;
					left: 22px;
					bottom: 8px;	
				}
				li {
					button {
						&:before {
							font-size: 12px;
							color: var(--neutral-300);
						}
					}
					&.slick-active {
						button {
							&:before {
								width: 10px;
								height: 10px;
								font-size: 0px;
								color: transparent;
								border-radius: 50%;
								border: 1px solid var(--neutral-300);
								margin: 4px 0 0 4px;
							}
						}
					}
				}
			} */
	}
`;

/* Render Component */
const CardsCarousel = ({ sectionTitle, data, placeholderImage }) => {
	// console.log('🚀 ~ file: CardsCarousel.js ~ line 262 ~ CardsCarousel ~ attractions',data);
	// const [sliderRef, setSliderRef] = useState(null)

	return (
        <div>
			{/* TODO: Make this sanity fields!!!!!! */}
			{sectionTitle &&
				<SectionTitle
				twoCol
				className='section-title'
				subtitle={sectionTitle.subheading}
				title={sectionTitle.title}
					// button={
					// 	sectionTitle.navItem ?
					// 		<GetLinks 
					// 		navItem={sectionTitle.navItem}
					// 		// buttonStyle='' 
					// 		/>
					// 	: false
					// }
					button={sectionTitle.navItem && <GetLinks navItem={sectionTitle.navItem} />}
				/>
			}

			<SliderStyles {...sliderSettings}>
				{data.map((card, index) => (
			// SPlit data into objects
			// If data is attractions - check img exists
			
					<a
						href={card.externalLink ? card.externalLink : '#'}
						target='_blank'
						key={index}
						className={card.externalLink ? 'card' : 'card no-link'}>
							{placeholderImage && <GatsbyImage image={getImage(card.featuredImg ? card.featuredImg.asset : placeholderImage.asset)} alt={card.name} className='attractions_slide-container' />}
							

						<div className='card-body'>
							<h3 className='card_title'>{card.name}</h3>
							<p className='card_description'>{card.attractionDescription}</p>
							<Button className='text-dark-btn card_link'>
								Continue Reading
							</Button>
						</div>
					</a>
				))}
			</SliderStyles>
		</div>
    );
};

export default CardsCarousel;
